import React from 'react';
import { Input, Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import type { InvoiceApprovalPreview } from '../api/invoiceWorkflowApi';

export default function InvoicePZNumbers({ orders, values, onChange, disabled }: {
  orders: InvoiceApprovalPreview['orders'];
  values: Record<string, string>;
  onChange: (values: Record<string, string>) => void;
  disabled: boolean;
}) {
  const { t } = useTranslation('invoices');
  const receipts = orders.filter(order => order.lines.length > 0);
  if (!receipts.length) return null;
  return <Space direction="vertical" style={{ width: '100%', marginBottom: 16 }}>
    <Typography.Text type="secondary">{t('workflow.pzNumbers.hint')}</Typography.Text>
    {receipts.map(order => <label key={order.id} style={{ display: 'block' }}>
      <span>{t('workflow.pzNumbers.label')}{order.orderNumber ? ` — ${order.orderNumber}` : ''}</span>
      <Input aria-label={`${t('workflow.pzNumbers.label')}${order.orderNumber ? ` — ${order.orderNumber}` : ''}`}
        value={values[order.id] ?? ''} maxLength={50} disabled={disabled}
        placeholder={t('workflow.pzNumbers.automatic')}
        onChange={event => onChange({ ...values, [order.id]: event.target.value })} />
    </label>)}
  </Space>;
}
